import COMBaseRegulation from "../com_base_regulation";
import {TimeSpan} from "@sparkware/app-utils";
import OptionsComponentController from "../../../../../components/options/options_component_controller";

export default class MaltaRegulation extends COMBaseRegulation {
  static CLASS = 'MaltaRegulation';

  protected realityCheckEnabled(): boolean {
    return true;
  }

  getRealityCheckInterval(): TimeSpan {
    return this.serviceFactory
        .componentFactoryService()
        .createComponent(OptionsComponentController)
        .getReminderInterval();
  }

  updateRealityCheckInterval(realityCheckIntevalMin: number): Promise<void> {
    if (!this.serviceFactory.oAuth2Service().isAuthorized()) {
        return Promise.reject();
    }
    // Set the reminder that use the setting from localStorage
    OptionsComponentController.create().load('ReminderSettings').set(realityCheckIntevalMin);
    return Promise.resolve();
}

  getRealityCheckIntervalExpectedByTheGame() {
    let interval = this.getRealityCheckInterval();
    return {
      timeSpan: interval,
      expectedValueByTheGame: Math.round(interval.totalSeconds),
    };
  }
}
